import React from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';

export const LabelValue = ({ label = '', value = '', active = false, toolTip = null }) => (
  <div className="calendar-meeting-folder-section-value">
    <Row>
      <Col xs="5" sm="6" lg="5" className={`label ${active && 'active'}`}>
        {label}
        {toolTip}
      </Col>
      <Col xs="7" sm="6" lg="7" className={`value ${active && 'active'}`}>
        {value}
      </Col>
    </Row>
  </div>
);

LabelValue.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  active: PropTypes.bool,
  toolTip: PropTypes.shape(),
};

LabelValue.defaultProps = {
  label: '',
  value: '',
  active: false,
  toolTip: null,
};
